/**
 * The render-target textures whose storage holds sRGB bytes under the sRGB tag their pass encodes
 * through. R3F stamps the same tag on any bound `map`, so the tag cannot tell them apart. Written
 * only by `markSrgbBytes`, and an entry goes with its texture.
 */
const srgbByteTextures = new WeakSet();
/** Marks `texture` as holding sRGB bytes that a canvas consumer filters raw. Returns it. */
export function markSrgbBytes(texture) {
    srgbByteTextures.add(texture);
    return texture;
}
/** Whether `texture` holds sRGB bytes under its sRGB tag, as a canvas-content target does. */
export function holdsSrgbBytes(texture) {
    return srgbByteTextures.has(texture);
}
//# sourceMappingURL=srgbByteTextures.js.map